import { render } from "./MeterReadingsForm.vue?vue&type=template&id=87700228"
import script from "./MeterReadingsForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./MeterReadingsForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script